<template>
  <div :is="field.size" class="form-section">{{ field.description }}</div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// HeaderRender.vue?55359746